import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { EmojiText } from './common/Picto';

interface FooterProps {
  onNavigateToPrivacy?: () => void;
  onNavigateToTerms?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigateToPrivacy, onNavigateToTerms }) => {
  const { t } = useTranslation();
  const handlePrivacy = () => {
    if (onNavigateToPrivacy) onNavigateToPrivacy();
    else window.location.href = '/privacy';
  };

  const handleTerms = () => {
    if (onNavigateToTerms) onNavigateToTerms();
    else window.location.href = '/terms';
  };

  return (
    <footer className="app-footer">
      <div className="app-footer__links">
        <button className="app-footer__link" onClick={handlePrivacy}>
          <EmojiText text={t('appFooter.privacy') as string} />
        </button>
        <div className="app-footer__sep" />
        <button className="app-footer__link" onClick={handleTerms}>
          <EmojiText text={t('appFooter.terms') as string} />
        </button>
        <div className="app-footer__sep" />
        <a className="app-footer__link" href="mailto:jogolinga@gmail.com">
          <EmojiText text={t('appFooter.contact') as string} />
        </a>
      </div>
      <p className="app-footer__copy">© {new Date().getFullYear()} JogoLinga</p>
    </footer>
  );
};

export default Footer;
